import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageTitle from "../elements/PageTitle";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const PackageDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pack, setPack] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPack = async () => {
      // Check if user is logged in
      const token = localStorage.getItem("token");
      
      if (!token) {
        // Show message to user
        // Store the intended destination for redirect after login
        localStorage.setItem("redirectAfterLogin", window.location.pathname);
        navigate("/login");
        return;
      }

      setLoading(true);

      try {
        const res = await fetch(`${API_BASE}/packs/${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.status === 401) {
          // Token expired or invalid, redirect to login
          localStorage.setItem("redirectAfterLogin", window.location.pathname);
          navigate("/login");
          return;
        }

        if (!res.ok) throw new Error("Pack not found.");

        const data = await res.json();
        setPack(data);
      } catch (err) {
        setError(err.message);
      }

      setLoading(false);
    };

    fetchPack();
  }, [id, navigate]);

  if (loading) return <p>Loading package...</p>;
  if (error) return <p className="text-danger">{error}</p>;
  if (!pack) return null;

  return (
    <div className="page-content">
      <PageTitle parentTitle={pack.name} />

      <section className="content-inner">
        <div className="container">

          <h2>{pack.name}</h2>
          <p>{pack.description}</p>
          <p><strong>Category:</strong> {pack.category_name}</p>

          <h3>Plans</h3>
          <ul>
            {pack.plans.map(plan => (
              <li key={plan._id}>
                {plan.label} — {plan.duration_days} days — ${(plan.price_cents / 100).toFixed(2)}
              </li>
            ))}
          </ul>

          <h3>Courses</h3>
          {pack.courses.length > 0 ? (
            <ul>
              {pack.courses.map(course => (
                <li key={course.id}>
                  <strong>{course.title}</strong>  
                  <p>{course.description}</p>
                  <small>Coach: {course.coach_name}</small>
                </li>
              ))}
            </ul>
          ) : (
            <p>No courses available for this package.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default PackageDetails;
